/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { JSONSearchParams } from './services/core/search.params';
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { ProfileApi } from './services/custom/Profile';
import { KanvasUserApi } from './services/custom/KanvasUser';
import { EmailApi } from './services/custom/Email';
import { ServicesApi } from './services/custom/Services';
import { PlayerApi } from './services/custom/Player';
import { AddressApi } from './services/custom/Address';
import { ImageApi } from './services/custom/Image';
import { QuickArtApi } from './services/custom/QuickArt';
import { VideoApi } from './services/custom/Video';
import { AudioApi } from './services/custom/Audio';
import { LibraryApi } from './services/custom/Library';
import { FeedApi } from './services/custom/Feed';
import { ScheduleApi } from './services/custom/Schedule';
import { ScreenApi } from './services/custom/Screen';
import { TutorialApi } from './services/custom/Tutorial';
import { StatisticApi } from './services/custom/Statistic';
import { LogApi } from './services/custom/Log';
import { InvitationCodeApi } from './services/custom/InvitationCode';
import { TagApi } from './services/custom/Tag';
import { ChatMessageApi } from './services/custom/ChatMessage';
import { ChatRoomApi } from './services/custom/ChatRoom';
import { LimitedTimeOfferApi } from './services/custom/LimitedTimeOffer';
import { OfferCodeApi } from './services/custom/OfferCode';
import { ContainerApi } from './services/custom/Container';
import { PlayerGroupApi } from './services/custom/PlayerGroup';
import { ScreenCategoryApi } from './services/custom/ScreenCategory';
import { CategoryRotationApi } from './services/custom/CategoryRotation';
import { ScheduleTimeframeApi } from './services/custom/ScheduleTimeframe';
import { ScheduleRotationApi } from './services/custom/ScheduleRotation';
import { PlayerSerialApi } from './services/custom/PlayerSerial';
import { RotationItemApi } from './services/custom/RotationItem';
import { KalipsoApi } from './services/custom/Kalipso';
import { ScreenLayoutApi } from './services/custom/ScreenLayout';
import { LayoutPanelApi } from './services/custom/LayoutPanel';
import { MigrationApi } from './services/custom/Migration';
import { PlayerVersionApi } from './services/custom/PlayerVersion';
import { ForecastApi } from './services/custom/Forecast';
import { PlayerCommandLogApi } from './services/custom/PlayerCommandLog';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        JSONSearchParams,
        SDKModels,
        RealTime,
        ProfileApi,
        KanvasUserApi,
        EmailApi,
        ServicesApi,
        PlayerApi,
        AddressApi,
        ImageApi,
        QuickArtApi,
        VideoApi,
        AudioApi,
        LibraryApi,
        FeedApi,
        ScheduleApi,
        ScreenApi,
        TutorialApi,
        StatisticApi,
        LogApi,
        InvitationCodeApi,
        TagApi,
        ChatMessageApi,
        ChatRoomApi,
        LimitedTimeOfferApi,
        OfferCodeApi,
        ContainerApi,
        PlayerGroupApi,
        ScreenCategoryApi,
        CategoryRotationApi,
        ScheduleTimeframeApi,
        ScheduleRotationApi,
        PlayerSerialApi,
        RotationItemApi,
        KalipsoApi,
        ScreenLayoutApi,
        LayoutPanelApi,
        MigrationApi,
        PlayerVersionApi,
        ForecastApi,
        PlayerCommandLogApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';




// WEBPACK FOOTER //
// ./src/app/shared/sdk/index.ts